import { licencesConstants } from "../_constants";

const initialState = {
    data: [],
    loading: false
}

export function licences(state = initialState, action) {
    switch (action.type) {
        case licencesConstants.LICENCES_LOADING:
            return {
                ...state,
                loading: true,
                data: []
            };
        case licencesConstants.LICENCES_LOADED:
            return {
                ...state,
                loading: false,
                data: action.data
            };
        case licencesConstants.LICENCES_ERROR:
            return {
                ...state,
                loading:false,
                data: []
            };
        default:
            return state;
    }
}